import { AdminUserHistoryDTO } from "@shaarp/common";
import { DataTable } from "../data-table/data-table";
import { dataTableAdminUsersHistoryColumns } from "./data-table-admin-users-history-columns";

export default function DataTableAdminUsersHistory({
  usersHistory,
  isLoading = false,
}: {
  usersHistory: AdminUserHistoryDTO[];
  isLoading?: boolean;
}) {
  return (
    <DataTable
      data={usersHistory}
      isLoading={isLoading}
      sortingState={[{ id: "Date", desc: true }]}
      columns={dataTableAdminUsersHistoryColumns()}
    />
  );
}
